import { render } from "./shinsei_Ringishoedit.vue?vue&type=template&id=2d219caa&scoped=true&ts=true"
import script from "./shinsei_Ringishoedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Ringishoedit.vue?vue&type=script&lang=ts"

import "./shinsei_Ringishoedit.vue?vue&type=style&index=0&id=2d219caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d219caa"]])

export default __exports__